import type {GoalModel} from '../../../domain/Goal/Goal.model';

export abstract class CreateGoalsInCourseCmd {
  abstract exec(
    props: CreateGoalsInCourseCmd.Props,
  ): Promise<CreateGoalsInCourseCmd.Response>;
}

export namespace CreateGoalsInCourseCmd {
  export type Props = {
    courseId: string;
    goals: GoalModel[];
    programId: string;
  };
  export type Response = GoalModel[];
}
